import { render, staticRenderFns } from "./DetailReporting.vue?vue&type=template&id=2c4683d2&scoped=true"
import script from "./DetailReporting.vue?vue&type=script&lang=js"
export * from "./DetailReporting.vue?vue&type=script&lang=js"
import style0 from "./DetailReporting.vue?vue&type=style&index=0&id=2c4683d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4683d2",
  null
  
)

export default component.exports